import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { LayoutSplashScreen } from "../../components/SplashScreen";
import AuthFooter from "../../components/AuthFooter";
import { useSelector } from "react-redux";
import AuthHeader from "../../components/AuthHeader";

const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const TeamPage = lazy(() => import("./team/TeamPage"));
const AcessosPage = lazy(() => import("./acessos/AcessosPage"));
const ConfiguracoesPage = lazy(() => import("./configuracoes/ConfiguracoesPage"));

export default function HomePage() {
	let routes = [];

	const { user } = useSelector((state) => state.auth);
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
		routes = [];
	}, [location.pathname]);

	const permissions = user?.permissions_format;

	if (!permissions || permissions.some((permission) => permission.controller === "Dashboard")) {
		routes.push(<Route key="/dashboard" path="/dashboard" component={DashboardPage} />);
	}

	if (!permissions || permissions.some((permission) => permission.controller === "Customer" || permission.controller === "Customergroup")) {
		routes.push(<Route key="/acessos" path="/acessos" component={AcessosPage} />);
	}

	if (!permissions || permissions.some((permission) => permission.controller === "Team")) {
		routes.push(<Route key="/Team" path="/Team" component={TeamPage} />);
	}

	if (!permissions || permissions.some((permission) => permission.controller === "Customercorporate")) {
		routes.push(<Route key="/configuracoes" path="/configuracoes" component={ConfiguracoesPage} />);
	}

	if (routes.length === 0) {
		routes.push(<Redirect key="redirect-404" to="/404" />);
	} else {
		routes.push(<Redirect key="redirect-default" to={routes[0].props.path} />);
	}

	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<div className="container">
				<AuthHeader />

				<div className="routeContainer">
					<Switch>{routes.map((route) => route)}</Switch>
				</div>

				<AuthFooter />
			</div>
		</Suspense>
	);
}